import lockerService from '@/api/locker'
import { LOCKER }  from '../types'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    lockers: [],
    pattern: '',
    lockerWithLocation: [],
    availableLockers: [],
    availableLockersForManager: [],
    locationsGroupedBySite: [],
    locationSiteId: null,
  },
  getters: {
    lockers: (state) => {
      return state.lockers
    },
    pattern: (state) => {
      return state.pattern
    },
    patternLockersIsValid: (state) => {
      return state.pattern && state.pattern.length > 0 ? state.pattern.includes("#") : false
    },
    availableLockersForManager: (state) => {
      return state.availableLockersForManager
    },
    siteLocations: (state) => {
      return state.locationsGroupedBySite.length > 0 && state.locationSiteId ? state.locationsGroupedBySite.find(site => site.id == state.locationSiteId).locations : []
    },
    locationSiteId: (state) => {
      return state.locationSiteId
    }
  },
  mutations: {
    [LOCKER.UPDATE_LOCKER] (state, locker) {
      state.lockers.set(locker.id, locker)
    },
    [LOCKER.LOCKER_SET] (state, lockers) {
      state.lockers = lockers
    },
    [LOCKER.PATTERN_SET](state, pattern) {
      state.pattern = pattern
    },
    [LOCKER.AVAILABLE_LOCKER_SET](state, availableLockers) {
        state.availableLockers = []
        state.availableLockers = availableLockers
    },
    [LOCKER.AVAILABLE_LOCKER_SET_FOR_MANAGER](state, lockers) {
      state.availableLockersForManager = lockers
    },
    [LOCKER.SET_LOCATIONS_GROUPED_BY_SITE] (state, locationsGroupedBySite) {
      state.locationsGroupedBySite = locationsGroupedBySite
    },
    [LOCKER.SET_SITE_ID] (state, locationSiteId) {
      state.locationSiteId = locationSiteId
    }
  },
  actions: {
    updateLocker ({commit}, data) {
      commit(LOCKER.UPDATE_LOCKER, data)
    },
    setAvailableLockersForManager ({commit}, lockers) {
      commit(LOCKER.AVAILABLE_LOCKER_SET_FOR_MANAGER, lockers)
    },
    async getAvailableLockers ({dispatch, commit}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let response = await lockerService.getAvailableLockers()
        commit(LOCKER.LOCKER_SET, response.data)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    findAvailableLockers: function ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            lockerService.findAvailableLockers(payload)
                .then((response) => {
                  commit(LOCKER.AVAILABLE_LOCKER_SET, response.data)
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
        })
    },
    findAvailableLockersForManager: function ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        lockerService.findAvailableLockers(payload)
          .then((response) => {
            commit(LOCKER.AVAILABLE_LOCKER_SET_FOR_MANAGER, response.data.filter(l => l.hasAvailableLockerSpots).map(x => x.locker))
            resolve(response.data)
          }).catch((error) => {
            commit(LOCKER.AVAILABLE_LOCKER_SET_FOR_MANAGER, [])
            reject(error)
          })
      })
    },
    async insertLocker({commit}, locker ){
      let lockerToChange = {
        active: true,
        hasBookings: false,
        id: locker.feature.id_,
        locationId: locker.locationId,
        name: locker.nextLockerName,
        numberOfSpots: 1,
        state: strings.pinStatus.inserted,
        x: locker.coordinates[0],
        y: locker.coordinates[1],
        bookable: true
      }
      await commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateTextLockerStore ({commit, state}, locker) {
      let lockerToChange = state.lockers.get(locker.id)
      locker.name ? lockerToChange.name = locker.name : lockerToChange.numberOfSpots = locker.numberOfSpots
      if(lockerToChange.state !== strings.pinStatus.inserted) {
        lockerToChange.state = strings.pinStatus.updated
      }
      commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateActiveLockerStore ({commit, state}, locker) {
      let lockerToChange = state.lockers.get(locker.id)
      lockerToChange.active = locker.active
      if(lockerToChange.state !== strings.pinStatus.inserted) {
        lockerToChange.state = strings.pinStatus.updated
      }
      commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateBookableLockerStore ({commit, state}, locker) {
      let lockerToChange = state.lockers.get(locker.id)
      lockerToChange.bookable = locker.bookable
      if(lockerToChange.state !== strings.pinStatus.inserted) {
        lockerToChange.state = strings.pinStatus.updated
      }
      commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateCoordinatesLockerStore({commit, state}, locker) {
      let selectedDesk = state.lockers.get(locker.id)
      selectedDesk.state = selectedDesk.state === strings.pinStatus.inserted ? strings.pinStatus.inserted : strings.pinStatus.updated
      selectedDesk.x = locker.coordinates[0]
      selectedDesk.y = locker.coordinates[1]
      commit(LOCKER.UPDATE_LOCKER, selectedDesk)
    },
    updateDeskCount ({commit}, count) {
      commit(LOCKER.LOCKERS_COUNT_SET, count)
    },
    setPattern ({commit}, pattern){
      commit(LOCKER.PATTERN_SET, pattern)
    },
    relateLockersToRegion: function ({dispatch}, relation) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        lockerService.relateLockersToRegion(relation).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getLockersByRegion: function ({dispatch}, regionId) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        lockerService.getLockersByRegion(regionId).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getLocationsGroupedBySite ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        lockerService.getLocationsGroupedBySite().then((response) => {
          commit(LOCKER.SET_LOCATIONS_GROUPED_BY_SITE, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    setLocationSiteId ({commit}, locationSiteId) {
      commit(LOCKER.SET_SITE_ID, locationSiteId)
    },
    // eslint-disable-next-line no-empty-pattern
    getLockers: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        lockerService.getLockers(locationId).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
  }
}
